import { DomainSubject } from "../../eventSubjects/domainSubject";


export class SlotRenderEndedSubjectData{
    isEmpty: boolean=true;
    divId?:string;
}
export class SlotRenderEndedSubject extends DomainSubject<SlotRenderEndedSubjectData>{
    name = "SlotRenderEndedSubject";
    init=()=>{}
}